// filepath: /Users/a1111/WebstormProjects/arch-editor/src/components/boards/BoardArchimate.js
import React from 'react';
import Canvas from '../Canvas';
import ToolbarArchimate from './ToolbarArchimate';

// Archimate доска: пустая логика (как free), отдельный режим на будущее
const BoardArchimate = ({ diagramId = null, projectId = null }) => {
  return <Canvas initialDiagramId={diagramId} mode="archimate" projectId={projectId} ToolbarComponent={ToolbarArchimate} />;
};

export default BoardArchimate;
